import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

const API_URL_OLD = "https://preview.keenthemes.com/metronic8/laravel/api"

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL_OLD}/verify_token`
export const LOGIN_URL = `${API_URL_OLD}/login`
export const JWT_AUTH = `${API_URL}/token/`
export const JWT_VERIFY = `${API_URL}/token/verify/`
export const JWT_REFRESH = `${API_URL}/token/refresh/`
export const JWT_LOGOUT = `${API_URL}/token/logout/`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`


// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function loginJWT(username: string, password: string) {
  // const username = email
  return axios.post<AuthModel>(JWT_AUTH, {
    username,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function verifyToken(token: string) {
  return axios.post<any>(JWT_VERIFY, {
    token,
  })
}

// Refresh access token using refresh token
export function refreshAccessToken(refreshToken: string) {
  return axios.post<{access: string}>(JWT_REFRESH, {
    refresh: refreshToken,
  })
}

// Logout and blacklist refresh token
export function logoutAndBlacklist(refreshToken: string) {
  return axios.post(JWT_LOGOUT, {
    refresh: refreshToken,
  })
}
